import classNames from 'classnames';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { LoaderSizes, cssSizes, loaderSizes } from './loaderSizes';
import { withCssSelector } from '../shared/withCssSelector';

const loaderKeyFrames = keyframes`
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
`;

const StyledLoader = styled.div<{
	size: LoaderSizes,
}>`
	display: inline-block;
	width: ${props => (cssSizes[props.size] || cssSizes.default).width};
	height: ${props => (cssSizes[props.size] || cssSizes.default).width};
	margin: 5px;
	border: solid ${props => (cssSizes[props.size] || cssSizes.default).border} transparent;
	border-top-color: currentColor;
	border-left-color: currentColor;
	border-radius: 100%;
	animation: ${loaderKeyFrames} 800ms linear infinite;

	.btn & {
		width: 18px;
		height: 18px;
		margin: -2px 5px 0 5px;
		vertical-align: middle;
	}
`;

export type LoaderProps = {
	size?: LoaderSizes,
	className?: string,
}

export const Loader = withCssSelector(React.forwardRef<HTMLDivElement, LoaderProps>(
	function Loader({ size = loaderSizes.sm, className }, ref) {
		return <StyledLoader ref={ref} className={classNames('loader', className)} size={size} />;
	}), StyledLoader.toString());

